// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { set as fn } from "../set.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setWithOptions;
